import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCheckUserRole } from '../hooks/useCheckUserRole';
import Select from 'react-select';
import ThemeToggleButton from '../../components/ThemeToggleButton';

function KapanisReyting() {
  const [isLoggedIn, setIsLoggedIn] = useState(localStorage.getItem('isLoggedIn') === 'true');
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [filters, setFilters] = useState(JSON.parse(localStorage.getItem('savedFilters')) || {});
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [perPage] = useState(50);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);

  const [userRole, setUserRole] = useState(localStorage.getItem('userRole'));

  const navigate = useNavigate();

  // Reyting DropDown
  const [selectedRating, setSelectedRating] = useState("");
  const [ratings, setRatings] = useState([]);

  // Tarih DropDown
  const [selectedDate, setSelectedDate] = useState('');
  const [matchDates, setMatchDates] = useState([]);

  // Maç DropDown
  const [matches, setMatches] = useState([]);
  const [selectedMatch, setSelectedMatch] = useState('');
  const [isDropdownClicked, setIsDropdownClicked] = useState(false);

  // ---- NEW: kolon bazlı filtre inputları ----
  const [inputValues, setInputValues] = useState({});
  const handleFilterChange = (key, value) => {
    setInputValues(prev => ({ ...prev, [key]: value }));
  };
  const toStr = (v) => (v === null || v === undefined ? "" : String(v));

  // Kullanıcı rolünü kontrol edin
  useCheckUserRole(['admin', 'editor', 'user', 'wait']);

  const columns = [
    {
      header: 'Maç Bilgileri',
      subColumns: [
        { key: 'match_date', header: 'Tarih' },
        { key: 'match_time', header: 'Saat' },
        { key: 'country_name', header: 'Ülke' },
        { key: 'season_name', header: 'Lig' },
        { key: 'home_team_name', header: 'Ev Sahibi' },
        { key: 'away_team_name', header: 'Deplasman' },
      ]
    },
    {
      header: 'Maç Sonucu Bilgileri',
      subColumns: [
        { key: 'first_half_score', header: 'İlk Yarı' },
        { key: 'second_half_score', header: 'İkinci Yarı' },
        { key: 'full_time_score', header: 'Maç Sonucu' },
        { key: 'ht_ft_result', header: 'İy / Ms' },
      ]
    },
    {
      header: 'Maç Sonucu',
      subColumns: [
        { key: 'ft_1_odd', header: '1' },
        { key: 'ft_x_odd', header: 'X' },
        { key: 'ft_2_odd', header: '2' },
      ]
    },
    {
      header: 'İlk Yarı',
      subColumns: [
        { key: 'fh_1_odd', header: '1' },
        { key: 'fh_x_odd', header: 'X' },
        { key: 'fh_2_odd', header: '2' },
      ]
    },
    {
      header: 'İkinci Yarı',
      subColumns: [
        { key: 'sh_1_odd', header: '1' },
        { key: 'sh_x_odd', header: 'X' },
        { key: 'sh_2_odd', header: '2' },
      ]
    },
    {
      header: '2.5 Üst Oranları',
      subColumns: [
        { key: 'ft_u_25_odd', header: 'Alt' },
        { key: 'ft_o_25_odd', header: 'Üst' },
      ]
    },
    {
      header: '3.5 Üst Oranları',
      subColumns: [
        { key: 'ft_u_35_odd', header: 'Alt' },
        { key: 'ft_o_35_odd', header: 'Üst' },
      ]
    },
  ];

  useEffect(() => {
    const storedIsLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
    setIsLoggedIn(storedIsLoggedIn);
    if (!storedIsLoggedIn) {
      navigate('/login');
    }
  }, [navigate]);

  useEffect(() => {
    fetch('api/Rating/Get/false', {
      headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.isSuccess) {
          const ratingNames = data.ratings.map((rating) => ({
            value: rating.value,
            label: rating.label,
          }));
          setRatings(ratingNames);
        } else {
          console.error('Reyting verisi alınamadı:', data.message);
        }
      })
      .catch((error) => console.error('Reyting API çağrısında hata:', error));
  }, []);

  const handleDropdownClick = () => {
    if (!isDropdownClicked && selectedRating) {
      fetch('/api/match-dates', {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` },
      })
        .then((response) => response.json())
        .then((dates) => {
          const labels = ["Bugün", "Yarın"];
          const filteredDates = dates.slice(0, 2);
          const formattedDates = filteredDates.map((date, index) => {
            const [yyyy, aa, gg] = date.split('-');
            return { formatted: `${yyyy}${aa}${gg}`, display: labels[index] };
          });
          setMatchDates(formattedDates);
          setIsDropdownClicked(true);
        })
        .catch((error) => console.error('Tarih alımında hata:', error));
    }
  };

  useEffect(() => {
    if (selectedDate && selectedRating) {
      const formattedDate = selectedDate;
      fetch(`/api/Rating/Matches/${selectedRating}/${formattedDate}`, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` },
      })
        .then((response) => response.json())
        .then((matches) => {
          if (matches && matches.matches) {
            setMatches(matches.matches);
          } else {
            console.error('Maç verisi alınamadı:', matches);
          }
        })
        .catch((error) => {
          console.error('Maç alımında hata:', error);
        });
    }
  }, [selectedDate, selectedRating]);

  useEffect(() => {
    if (selectedMatch && selectedRating) {
      const fetchFilteredData = async () => {
        try {
          setLoading(true);
          const response = await fetch(`/api/Rating/Filter/${selectedMatch}/${selectedRating}`, {
            headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` },
          });
          const result = await response.json();

          if (response.ok && result.isSuccess) {
            setFilteredData(result.table || []);
          } else {
            console.error('Filtre API hatası:', result.message || 'Bilinmeyen hata');
            setFilteredData([]);
          }
        } catch (error) {
          console.error('API çağrısı başarısız:', error);
          setFilteredData([]);
        } finally {
          setLoading(false);
        }
      };
      fetchFilteredData();
    }
  }, [selectedMatch, selectedRating]);

  const matchOptions = matches
    .filter(match => match.id)
    .map(match => ({
      value: match.id,
      label: `${match.country} | ${match.league} | ${match.time} - ${match.name}`,
    }));

  const handleRefreshRequest = () => {
    if (selectedMatch && selectedRating) {
      const fetchFilteredData = async () => {
        try {
          setLoading(true);
          const response = await fetch(`/api/Rating/Filter/${selectedMatch}/${selectedRating}`, {
            headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` },
          });
          const result = await response.json();

          if (response.ok && result.isSuccess) {
            setFilteredData(result.table || []);
          } else {
            console.error('Yenile API hatası:', result.message || 'Bilinmeyen hata');
            setFilteredData([]);
          }
        } catch (error) {
          console.error('Yenile API çağrısı başarısız:', error);
          setFilteredData([]);
        } finally {
          setLoading(false);
        }
      };
      fetchFilteredData();
    }
  };

  // ---- NEW: client-side filtreleme (tüm subColumn inputları)
  const visibleSubColumns = useMemo(() => {
    return columns
      .filter(col => col.subColumns)
      .flatMap(col => col.subColumns);
  }, [columns]);

  const displayRows = useMemo(() => {
    if (!filteredData?.length) return [];
    const activeFilters = Object.entries(inputValues)
      .filter(([, val]) => val && val.trim() !== "");
    if (activeFilters.length === 0) return filteredData;

    const visibleKeys = new Set(visibleSubColumns.map(sc => sc.key));

    return filteredData.filter(row => {
      return activeFilters.every(([key, needle]) => {
        if (!visibleKeys.has(key)) return true;
        const hay = toStr(row[key]).toLowerCase();
        const ned = String(needle).toLowerCase();
        return hay.includes(ned);
      });
    });
  }, [filteredData, inputValues, visibleSubColumns]);

  return (
    <>
      {loading && <div className="loader">
        <div className="loader-inner">
          <div className="circle"></div>
        </div>
      </div>}

      <div className="breadcrumb-section breadcrumb-bg">
        <div className="full-width">
          <div className="row">
            <div className="col-lg-8 offset-lg-2 text-center">
              <div className="breadcrumb-text">
                <p>Kapanış Reyting</p>
                <h1>Tablosu</h1>
              </div>
            </div>
          </div>
        </div>
      </div>

      {userRole === 'wait' ? (
        <div className="text-center">
          <h2>Bu içeriği görüntüleyebilmek için üyelik satın almanız gerekmektedir.</h2>
          <button className="btn btn-primary" onClick={() => navigate('/satinal')}>
            Üyelik Satın Al
          </button>
        </div>
      ) : (
        <div className="full-width filter">
          <ThemeToggleButton />

          <div className="row">
            <div className="col-lg-6">
              <h3>Reyting Seçimi</h3>

              <div className="filter-container">
                <select
                  value={selectedRating}
                  onChange={(e) => {
                    setSelectedRating(e.target.value);
                    setIsDropdownClicked(false);
                    setSelectedDate("");
                    setMatches([]);
                  }}
                  className="form-control filter-dropdown"
                >
                  <option value="">Reyting Seçin</option>
                  {ratings.map((rating, index) => (
                    <option key={index} value={rating.value}>
                      {rating.label}
                    </option>
                  ))}
                </select>

                {selectedRating && (
                  <select
                    value={selectedDate}
                    onChange={(e) => setSelectedDate(e.target.value)}
                    onClick={handleDropdownClick}
                    className="form-control filter-dropdown"
                  >
                    <option value="">Tarih Seçin</option>
                    {matchDates.map(({ formatted, display }, index) => (
                      <option key={index} value={formatted}>
                        {display}
                      </option>
                    ))}
                  </select>
                )}

                {selectedDate && selectedRating && (
                  <div className="match-select-container" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <Select
                      value={matchOptions.find(option => option.value === selectedMatch)}
                      onChange={(selectedOption) => setSelectedMatch(selectedOption ? selectedOption.value : null)}
                      options={matchOptions}
                      placeholder="Maç Seçin"
                      isSearchable
                      classNamePrefix="filter-dropdown"
                    />
                    {selectedMatch && (
                      <button
                        className="refresh-button"
                        onClick={handleRefreshRequest}
                        title="Yenile"
                      >
                        🔄 {/* Yenile buton simgesi */}
                      </button>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>

          {!error && (
            <div className="table-wrapper acilis-table-wrapper">
              <table className="table">
                <thead>
                  <tr className="top-header">
                    {columns.map((column, index) => (
                      column.subColumns ? (
                        <th colSpan={column.subColumns.length} key={index}>
                          {column.header}
                        </th>
                      ) : (
                        <th key={column.key}>
                          {column.header}
                        </th>
                      )
                    ))}
                  </tr>
                  {/* NEW: Filtre input satırı */}
                  <tr>
                    {columns.map((column, index) => (
                      column.subColumns ? (
                        column.subColumns.map(subColumn => (
                          <th key={subColumn.key}>
                            {subColumn.header}
                            <input
                              type="text"
                              className="filter-input"
                              placeholder="Filtre"
                              value={inputValues[subColumn.key] || ''}
                              onChange={(e) => handleFilterChange(subColumn.key, e.target.value)}
                              style={{ marginTop: 6 }}
                            />
                          </th>
                        ))
                      ) : (
                        <th key={index}></th>
                      )
                    ))}
                  </tr>
                </thead>

                <tbody>
                  {displayRows.length > 0 ? (
                    displayRows.map((item, index) => (
                      <tr key={index}>
                        {columns.map((column) => (
                          column.subColumns ? (
                            column.subColumns.map(subColumn => (
                              <td key={subColumn.key}>{toStr(item[subColumn.key])}</td>
                            ))
                          ) : (
                            <td key={column.key}>{toStr(item[column.key])}</td>
                          )
                        ))}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={columns.reduce((sum, column) => sum + (column.subColumns ? column.subColumns.length : 1), 0)}>
                        {filteredData.length ? 'Filtrenize uygun sonuç yok' : 'Lütfen Yukarıdan Seçim Yapın'}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}
    </>
  );
}
export default KapanisReyting;
